<template>
  <MainContainer />
</template>

<script setup lang="ts">
// eslint-disable-next-line import/no-unresolved -- Vite resolves the selected build-time template.
import MainContainer from '@template'

import { useDescriptorsSEO } from '@/composables/useDescriptorsSEO'

if (import.meta.env.SSR) {
  useDescriptorsSEO()
}
</script>
